// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1747470359630
      var cssReload = require("../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/style.scss
// module id = ./src/components/Loader/style.scss
// module chunks = 0